import React from "react";
import { useTranslation } from "react-i18next";
import "./AssessmentSteps.css";

const AssessmentSteps: React.FC = () => {
  const { t } = useTranslation();

  const steps = [
    {
      number: "01",
      title: t("step_1_title"),
      description: t("step_1_description"),
    },
    {
      number: "02",
      title: t("step_2_title"),
      description: t("step_2_description"),
    },
    {
      number: "03",
      title: t("step_3_title"),
      description: t("step_3_description"),
    },
    {
      number: "04",
      title: t("step_4_title"),
      description: t("step_4_description"),
    },
  ];

  return (
    <div className="assessment-steps-container">
      <h2 className="assessment-steps-title">{t("assessment_title")}</h2>
      <div className="steps-grid">
        {steps.map((step, index) => (
          <div className="step-card" key={index}>
            <span className="step-number">{step.number}</span>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-description">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AssessmentSteps;
